var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pathImage)?_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"img-fluid",class:_vm.css,attrs:{"src":_vm.path,"alt":"review image"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }